import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchJSON} from '../../../helpers/FetchUtils';
import {
    CONFIRM_MODAL
} from './constants';
import {
    confirmModalSuccess, confirmModalFail
} from './actions';
import {catchError, showErrorToast} from "../../../util/ErrorCatchUtils";
import {layoutMainSignCheck} from "../layouts/main/actions";
import {isEmpty} from "../../../helpers/EmptyUtils";

// 通用模态窗口
function* confirmModal({payload: {params}}) {
    try {
        const {values, url} = params;
        if(isEmpty(url)) {
            return;
        }
        const response = yield call(fetchJSON, url, {body: JSON.stringify(values)});
        if (response.success) {
            let responseData = response.data;
            yield put(confirmModalSuccess({saveDatas: {...responseData}}));
        } else {
            yield put(layoutMainSignCheck({...response, showToast: true}));
            yield put(confirmModalFail(response));
        }
    } catch (error) {
        yield put(layoutMainSignCheck(showErrorToast(error)));
        yield put(confirmModalFail(catchError(error)));
    }
}

//
export function* confirmModalWatcher() {
    yield takeEvery(CONFIRM_MODAL, confirmModal);
}

//
function* ConfirmModalSaga() {
    yield all([
        fork(confirmModalWatcher)
    ]);
}

//
export default ConfirmModalSaga;
